<template>
  <div class="kpi-module-style">
    <b-field
      label="KPIs per row"
      class="input-field"
      message="Cards wrap onto a new row once this many have been placed.">
      <b-numberinput
        v-model="inputs.columns_per_row"
        :min="1"
        :max="8"
        controls-alignment="right"
        expanded />
    </b-field>

    <b-field
      label="Card width"
      class="input-field">
      <b-numberinput
        v-model="inputs.card_width"
        :min="80"
        :step="8"
        controls-alignment="right"
        expanded />
    </b-field>

    <b-field
      label="Gap between cards"
      class="input-field">
      <b-numberinput
        v-model="inputs.card_gutter"
        :min="0"
        :step="2"
        controls-alignment="right"
        expanded />
    </b-field>

    <b-field class="input-field">
      <b-switch
        v-model="inputs.show_card_background"
        type="is-info">
        Give each card a background
      </b-switch>
    </b-field>

    <b-field
      label="Shown when a value has no data"
      class="input-field"
      message="A blank KPI reads as a broken one. Clear this to leave such values empty instead.">
      <b-input
        v-model="inputs.null_placeholder"
        placeholder="—" />
    </b-field>

    <b-field class="input-field">
      <b-switch
        v-model="inputs.add_divider"
        type="is-info">
        Add a divider below the KPIs
      </b-switch>
    </b-field>

    <b-field
      label="Space before"
      class="input-field">
      <b-numberinput
        v-model="inputs.space_before"
        :min="0"
        controls-alignment="right"
        expanded />
    </b-field>

    <b-field
      label="Space after"
      class="input-field">
      <b-numberinput
        v-model="inputs.space_after"
        :min="0"
        controls-alignment="right"
        expanded />
    </b-field>
  </div>
</template>

<script>
  import { DEFAULT_KPI_MODULE_STYLE } from '@/components/pdf_report/kpi_module/defaults'

  export default {
    name: 'KpiModuleStyle',
    props: {
      value: {
        type: Object,
        default: null,
      },
    },
    computed: {
      inputs: {
        get () {
          return this.value || {}
        },
        set (value) {
          this.$emit('input', value)
        },
      },
    },
    mounted () {
      if (!this.value) {
        this.inputs = { ...DEFAULT_KPI_MODULE_STYLE, }
      }
    },
  }
</script>
